<div class="px-2 h-full">
  <vw-card customClasses="bg-white h-full">
    <div class="rounded-xl flex justify-center flex-col  w-full p-[8px]">
      <div class="w-full relative aspect-square grid" [ngClass]="{
          'grid-cols-1 grid-rows-1': hierarchy.cultivations.length === 1,
          'grid-cols-2 grid-rows-2 gap-2': hierarchy.cultivations.length > 1
       }">
        <!-- TODO maybe use this even when there is only one variant and make it full width/height -->
        @for (cultivation of hierarchy.cultivations.slice(0, 3); track cultivation) {
        <vw-cultivation-item-viewer [cultivation]="cultivation"
          [displayType]="hierarchy.cultivations.length > 1 ? 'SMALL' : 'BIG'" class="w-full h-full">
        </vw-cultivation-item-viewer>
        }
        @if (hierarchy.cultivations.length > 3) {
        <div class="flex items-center text-xl justify-center w-full h-full bg-primary-200 text-white rounded-lg">
          +{{hierarchy.cultivations.length - 3}}
        </div>
        }
        @if (actionRequired) {
        <!-- Badge unique pour tout le regroupement (cf. cultures groupées), posé sur l'image. -->
        <vw-action-badge class="absolute left-1 top-1 z-[9]"
          [ariaLabel]="'garden.overview.action-todo' | translate"></vw-action-badge>
        }
      </div>

      <div class="mt-2 w-full">
        <h3 class="text-xl font-semibold text-[#023E42] truncate">
          {{ hierarchy.cultivations.length > 1 ? hierarchy.name : hierarchy.cultivations[0].name }}
        </h3>
        @if (hierarchy && hierarchy.cultivations && hierarchy.cultivations.length > 0) {
        <p class="text-xs font-normal text-[#9DA4A2] flex  items-center text-left justify-start leading-5">
          <vw-icon-svg [iconUrl]="'/assets/svg/garden.svg'" additionalClasses="cursor-pointer z-[9] relative mr-2"
            width="18" height="18"></vw-icon-svg>
          {{ 'garden.components.user-hierarchy-item.cultivations-count' | translate: {count:
          hierarchy.cultivations.length} }}
        </p>
        }
      </div>
    </div>
  </vw-card>
</div>